import { ContextMenuHandler, ContextWindow } from "@asup/context-menu";
import { useState } from "react";
import { IDraggableSidebarItemResolved } from "../../controls";
import { classMerge } from "../../utility";
import { GroupingFactorControl } from "../components";
import { ArsSidebarItemGroupingFactor } from "./interface";

export interface GroupingFactorSidebarItemProps {
  item: IDraggableSidebarItemResolved<ArsSidebarItemGroupingFactor>;
  selected?: boolean;
}

/**
 * Custom sidebar item renderer for grouping factors.
 *
 * @param props - Props containing the sidebar item and selection state
 * @param props.item - Sidebar item with grouping factor drag data
 * @param props.selected - Whether the item is currently selected
 * @returns Grouping factor display element
 */
export const GroupingFactorSidebarItem = ({ item, selected }: GroupingFactorSidebarItemProps) => {
  const groupingFactor = item.data.dropItem;
  const [showWindow, setShowWindow] = useState<boolean>(false);

  return (
    <>
      <ContextMenuHandler
        className="w-100"
        menuItems={[
          {
            label: showWindow ? "Hide properties" : "Show properties",
            action: () => setShowWindow(!showWindow),
          },
        ]}
      >
        <div
          className={classMerge([
            "grouping-factor-sidebar-item",
            "px-2",
            "py-1",
            "border",
            "rounded",
            "w-100",
            selected ? "border-primary bg-primary-subtle" : "",
          ])}
          style={{ cursor: "grab" }}
        >
          <div className="fw-semibold">{item.label}</div>
          <small className="text-muted">
            {groupingFactor.dataDriven ? "Data driven" : "Groups"} • {groupingFactor.name}{" "}
            {groupingFactor.disableEditing ? <em className="px-1">• Read only</em> : null}
          </small>
        </div>
      </ContextMenuHandler>
      <ContextWindow
        id={`grouping-factor-sidebar-item-${groupingFactor.id}-context-window`}
        minZIndex={1000}
        title={`Grouping Factor: ${groupingFactor.name}`}
        visible={showWindow}
        onClose={() => setShowWindow(false)}
      >
        <GroupingFactorControl
          dataPath={`/groupingFactors/${groupingFactor.id}`}
          canRename
        />
      </ContextWindow>
    </>
  );
};

GroupingFactorSidebarItem.displayName = "GroupingFactorSidebarItem";
